/* BLK_MOBILE_PRODUCT_DETAIL_JS_START 20260708 */
(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var mediaQuery = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
  var state = {
    purchaseRow: null,
    quantityPlaceholder: null,
    addButtonPlaceholder: null,
    initFrame: null,
    retryTimers: []
  };

  function isMobile() {
    return !mediaQuery || mediaQuery.matches;
  }

  function applyJudgeMeReviewLayout() {
    if (document.getElementById('blk-judgeme-review-layout')) return;

    var style = document.createElement('style');
    style.id = 'blk-judgeme-review-layout';
    style.textContent = [
      '@media screen and (min-width: 750px) {',
      '  .shopify-app-block:has(#judgeme_product_reviews),',
      '  .shopify-app-block #judgeme_product_reviews,',
      '  .shopify-app-block .jdgm-review-widget { width: 100% !important; max-width: 100% !important; }',
      '  #judgeme_product_reviews .jdgm-rev-widg { padding: 0 !important; }',
      '  #judgeme_product_reviews .jdgm-rev-widg__header { display: block !important; border-bottom: 1px solid rgba(var(--color-foreground), 0.08); padding-bottom: 3rem; }',
      '  #judgeme_product_reviews .jdgm-rev-widg__title { display: block !important; width: 100% !important; margin: 0 0 2.6rem; text-align: left !important; }',
      '  #judgeme_product_reviews .blk-jdgm-review-toolbar { display: grid; grid-template-columns: minmax(0, 1fr) 28rem 15rem; align-items: center; column-gap: 1.2rem !important; width: 100%; }',
      '  #judgeme_product_reviews .blk-jdgm-review-summary { justify-self: start; min-width: 32rem; }',
      '  #judgeme_product_reviews .blk-jdgm-review-actions { justify-self: stretch; display: flex; justify-content: flex-end; width: 100%; }',
      '  #judgeme_product_reviews .blk-jdgm-review-sort { justify-self: start; min-width: 0; text-align: left; }',
      '  #judgeme_product_reviews .jdgm-row-stars[data-blk-jdgm-source], #judgeme_product_reviews .jdgm-row-actions[data-blk-jdgm-source] { display: contents !important; }',
      '  #judgeme_product_reviews .blk-jdgm-review-toolbar .blk-jdgm-review-summary, #judgeme_product_reviews .blk-jdgm-review-toolbar .blk-jdgm-review-summary .jdgm-rev-widg__summary { display: flex !important; justify-content: flex-start; min-width: 32rem; margin: 0 !important; }',
      '  #judgeme_product_reviews .jdgm-histogram { display: none !important; }',
      '  #judgeme_product_reviews .jdgm-widget-actions-wrapper { display: flex !important; align-items: center; justify-content: center; width: 100% !important; margin: 0 !important; }',
      '  #judgeme_product_reviews .blk-jdgm-review-toolbar .blk-jdgm-review-actions .jdgm-write-rev-link { display: inline-flex !important; align-items: center; justify-content: center; width: 100%; min-width: 28rem; min-height: 4.6rem; margin: 0 !important; padding: 0 3.2rem !important; border-radius: 0 !important; background-color: #000 !important; color: #fff !important; font-weight: 700 !important; line-height: 1.2 !important; text-align: center; text-decoration: none !important; }',
      '  #judgeme_product_reviews .jdgm-rev-widg__sort-wrapper, #judgeme_product_reviews .jdgm-sort-dropdown-wrapper { display: inline-flex !important; align-items: center; width: auto; margin: 0 !important; }',
      '  #judgeme_product_reviews .jdgm-sort-dropdown { display: block !important; min-width: 14rem; margin: 0 !important; text-align: left; }',
      '}',
      '@media screen and (max-width: 749px) {',
      '  #judgeme_product_reviews .jdgm-rev-widg__header { display: block !important; padding-bottom: 1.8rem; border-bottom: 1px solid rgba(var(--color-foreground), 0.08); }',
      '  #judgeme_product_reviews .jdgm-rev-widg__title { display: block !important; width: 100% !important; margin: 0 0 1.4rem; text-align: center !important; }',
      '  #judgeme_product_reviews .blk-jdgm-review-toolbar { display: grid; grid-template-columns: minmax(0, 1fr) minmax(10rem, auto); align-items: center; column-gap: 1rem; row-gap: 1.6rem; width: 100%; }',
      '  #judgeme_product_reviews .blk-jdgm-review-summary { grid-column: 1 / -1; justify-self: center; min-width: 0; }',
      '  #judgeme_product_reviews .blk-jdgm-review-actions { grid-column: 1; justify-self: stretch; min-width: 0; }',
      '  #judgeme_product_reviews .blk-jdgm-review-sort { grid-column: 2; justify-self: end; min-width: 10rem; }',
      '  #judgeme_product_reviews .jdgm-row-stars[data-blk-jdgm-source], #judgeme_product_reviews .jdgm-row-actions[data-blk-jdgm-source] { display: contents !important; }',
      '  #judgeme_product_reviews .blk-jdgm-review-toolbar .blk-jdgm-review-summary, #judgeme_product_reviews .blk-jdgm-review-toolbar .blk-jdgm-review-summary .jdgm-rev-widg__summary { display: flex !important; justify-content: center; margin: 0 !important; }',
      '  #judgeme_product_reviews .jdgm-histogram { display: none !important; }',
      '  #judgeme_product_reviews .jdgm-widget-actions-wrapper { display: flex !important; margin: 0 !important; min-width: 0; }',
      '  #judgeme_product_reviews .blk-jdgm-review-toolbar .blk-jdgm-review-actions .jdgm-write-rev-link { display: inline-flex !important; align-items: center; justify-content: center; width: 100%; min-height: 4rem; margin: 0 !important; padding: 0 1.2rem !important; border-radius: 0 !important; background-color: #000 !important; color: #fff !important; font-weight: 700 !important; line-height: 1.2 !important; text-align: center; text-decoration: none !important; }',
      '  #judgeme_product_reviews .jdgm-rev-widg__sort-wrapper, #judgeme_product_reviews .jdgm-sort-dropdown-wrapper { display: inline-flex !important; align-items: center; width: 100%; margin: 0 !important; }',
      '  #judgeme_product_reviews .jdgm-sort-dropdown { display: block !important; width: 100%; min-width: 10rem; margin: 0 !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function ensureJudgeMeSlot(toolbar, className) {
    var slot = toolbar.querySelector(':scope > .' + className);
    if (!slot) {
      slot = document.createElement('div');
      slot.className = className;
      toolbar.appendChild(slot);
    }
    return slot;
  }

  function organizeJudgeMeReviewHeader() {
    var root = document.querySelector('#judgeme_product_reviews');
    var header = root && root.querySelector('.jdgm-rev-widg__header');
    if (!header) return;

    var title = header.querySelector('.jdgm-rev-widg__title');
    var rowStars = header.querySelector('.jdgm-row-stars');
    var summary = header.querySelector('.jdgm-rev-widg__summary');
    var histogram = header.querySelector('.jdgm-histogram');
    var actionWrapper = header.querySelector('.jdgm-widget-actions-wrapper');
    var writeLink = header.querySelector('.jdgm-write-rev-link');
    var rowActions = root.querySelector('.jdgm-row-actions');
    var sortWrapper = root.querySelector('.jdgm-rev-widg__sort-wrapper') || root.querySelector('.jdgm-sort-dropdown-wrapper');

    if (histogram) histogram.setAttribute('data-blk-jdgm-hidden', 'true');
    if (!summary || !writeLink || !sortWrapper) return;

    var toolbar = header.querySelector(':scope > .blk-jdgm-review-toolbar');
    if (!toolbar) {
      toolbar = document.createElement('div');
      toolbar.className = 'blk-jdgm-review-toolbar';
      if (title && title.nextSibling) {
        header.insertBefore(toolbar, title.nextSibling);
      } else {
        header.appendChild(toolbar);
      }
    }

    var summarySlot = ensureJudgeMeSlot(toolbar, 'blk-jdgm-review-summary');
    var actionsSlot = ensureJudgeMeSlot(toolbar, 'blk-jdgm-review-actions');
    var sortSlot = ensureJudgeMeSlot(toolbar, 'blk-jdgm-review-sort');

    if (summary.parentNode !== summarySlot) summarySlot.appendChild(summary);
    if (actionWrapper) {
      if (actionWrapper.parentNode !== actionsSlot) actionsSlot.appendChild(actionWrapper);
    } else if (writeLink.parentNode !== actionsSlot) {
      actionsSlot.appendChild(writeLink);
    }
    if (sortWrapper.parentNode !== sortSlot) sortSlot.appendChild(sortWrapper);

    if (rowStars) rowStars.setAttribute('data-blk-jdgm-source', 'true');
    if (rowActions) rowActions.setAttribute('data-blk-jdgm-source', 'true');
    header.setAttribute('data-blk-jdgm-organized', 'true');
  }

  function normalizeText(text) {
    return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function getVisibleLabelText(label) {
    var clone = label.cloneNode(true);
    Array.prototype.slice.call(clone.querySelectorAll('.visually-hidden, .hidden, [hidden], [aria-hidden="true"], svg')).forEach(function (node) {
      node.parentNode.removeChild(node);
    });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function findSizeFieldset(root) {
    var fieldsets = Array.prototype.slice.call((root || document).querySelectorAll('.product-form__input--pill'));
    return fieldsets.find(function (fieldset) {
      var label = fieldset.querySelector('.form__label');
      return label && normalizeText(label.textContent).indexOf('grootte') !== -1;
    }) || null;
  }

  function hasCheckedHiddenOption(fieldset) {
    var inputs = Array.prototype.slice.call(fieldset.querySelectorAll('input[type="radio"]'));
    return inputs.some(function (input, index) { return index >= 4 && input.checked; });
  }

  function placeToggleAfterFourthSize(fieldset, toggle) {
    var labels = Array.prototype.slice.call(fieldset.querySelectorAll(':scope > input[type="radio"] + label'));
    var collapsedCount = getCollapsedVisibleCount(fieldset, labels);
    var target = labels[Math.max(0, collapsedCount - 1)];
    if (!target) return;
    if (target.nextElementSibling !== toggle) {
      target.parentNode.insertBefore(toggle, target.nextSibling);
    }
  }

  function getCollapsedVisibleCount(fieldset, labels) {
    var fieldsetWidth = fieldset.getBoundingClientRect().width || window.innerWidth || 360;
    var style = window.getComputedStyle ? window.getComputedStyle(fieldset) : null;
    var gap = style ? parseFloat(style.columnGap || style.gap || 0) : 8;
    var pillWidth = parseFloat(fieldset.style.getPropertyValue('--blk-size-pill-width')) || (labels[0] && labels[0].getBoundingClientRect().width) || 68;
    var perRow = Math.floor((fieldsetWidth + gap) / (pillWidth + gap));
    perRow = Math.max(2, perRow);
    return Math.max(1, Math.min(labels.length, perRow - 1));
  }

  function updateCollapsedSizeOptions(fieldset) {
    var labels = Array.prototype.slice.call(fieldset.querySelectorAll(':scope > input[type="radio"] + label'));
    var inputs = Array.prototype.slice.call(fieldset.querySelectorAll(':scope > input[type="radio"]'));
    var collapsedCount = getCollapsedVisibleCount(fieldset, labels);
    fieldset.setAttribute('data-blk-collapsed-count', String(collapsedCount));
    inputs.forEach(function (input, index) {
      input.classList.toggle('blk-size-collapsed-hidden', index >= collapsedCount);
    });
  }

  function updateSizePillWidth(fieldset) {
    var labels = Array.prototype.slice.call(fieldset.querySelectorAll(':scope > input[type="radio"] + label'));
    if (!labels.length) return;

    fieldset.setAttribute('data-blk-size-adaptive', 'true');

    var sample = labels[0];
    var style = window.getComputedStyle ? window.getComputedStyle(sample) : null;
    var canvas = updateSizePillWidth.canvas || (updateSizePillWidth.canvas = document.createElement('canvas'));
    var context = canvas.getContext && canvas.getContext('2d');
    if (context && style) {
      context.font = [
        style.fontStyle,
        style.fontVariant,
        style.fontWeight,
        style.fontSize,
        style.fontFamily
      ].filter(Boolean).join(' ');
    }

    var maxTextWidth = labels.reduce(function (maxWidth, label) {
      var text = getVisibleLabelText(label);
      var width = context ? context.measureText(text).width : text.length * 8;
      return Math.max(maxWidth, width);
    }, 0);

    var paddingX = style ? parseFloat(style.paddingLeft || 0) + parseFloat(style.paddingRight || 0) : 16;
    var borderX = style ? parseFloat(style.borderLeftWidth || 0) + parseFloat(style.borderRightWidth || 0) : 2;
    var fieldsetWidth = fieldset.getBoundingClientRect().width || window.innerWidth || 360;
    var targetWidth = Math.ceil(maxTextWidth + paddingX + borderX + 4);
    targetWidth = Math.max(58, Math.min(targetWidth, Math.floor(fieldsetWidth)));

    var nextWidth = targetWidth + 'px';
    if (fieldset.style.getPropertyValue('--blk-size-pill-width') !== nextWidth) {
      fieldset.style.setProperty('--blk-size-pill-width', nextWidth);
    }
  }

  function ensureToggle(fieldset) {
    var inputs = fieldset.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return;

    fieldset.setAttribute('data-blk-mobile-size-picker', 'true');
    updateSizePillWidth(fieldset);

    if (inputs.length <= 4) {
      var existingToggle = fieldset.querySelector(':scope > .blk-size-toggle');
      if (existingToggle) existingToggle.parentNode.removeChild(existingToggle);
      return;
    }

    if (!fieldset.getAttribute('data-blk-expanded')) {
      fieldset.setAttribute('data-blk-expanded', hasCheckedHiddenOption(fieldset) ? 'true' : 'false');
    }

    var toggle = fieldset.querySelector(':scope > .blk-size-toggle');
    if (!toggle) {
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'blk-size-toggle';
      toggle.setAttribute('aria-label', 'Toon meer maten');
    }

    updateCollapsedSizeOptions(fieldset);
    placeToggleAfterFourthSize(fieldset, toggle);
    toggle.setAttribute('aria-expanded', fieldset.getAttribute('data-blk-expanded') === 'true' ? 'true' : 'false');
    if (!toggle.dataset.blkBound) {
      toggle.dataset.blkBound = 'true';
      toggle.addEventListener('click', function () {
        var expanded = fieldset.getAttribute('data-blk-expanded') === 'true';
        fieldset.setAttribute('data-blk-expanded', expanded ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }
  }

  function findQuantityBlock() {
    return document.querySelector('.product-form__quantity[id^="Quantity-Form-"]');
  }

  function findAddToCartButton() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return null;
    var button = document.querySelector('.product-form__submit[type="submit"], button[name="add"][type="submit"]');
    if (!button) return null;
    var formId = form.getAttribute('id');
    if (formId && button.getAttribute('form') !== formId) button.setAttribute('form', formId);
    return button;
  }

  function ensurePlaceholder(node, key, label) {
    if (!state[key]) state[key] = document.createComment(label);
    if (node && node.parentNode && !state[key].parentNode) node.parentNode.insertBefore(state[key], node);
    return state[key];
  }

  function setupPurchaseRow() {
    var quantity = findQuantityBlock();
    var addButton = findAddToCartButton();
    if (!quantity || !addButton) return;

    ensurePlaceholder(quantity, 'quantityPlaceholder', 'BLK mobile quantity original position');
    ensurePlaceholder(addButton, 'addButtonPlaceholder', 'BLK mobile add button original position');

    if (!state.purchaseRow) {
      state.purchaseRow = document.createElement('div');
      state.purchaseRow.className = 'blk-mobile-purchase-row';
    }

    if (!state.purchaseRow.parentNode && addButton.parentNode) {
      addButton.parentNode.insertBefore(state.purchaseRow, addButton);
    }

    if (!state.purchaseRow.contains(quantity)) state.purchaseRow.appendChild(quantity);
    if (!state.purchaseRow.contains(addButton)) state.purchaseRow.appendChild(addButton);
  }

  function restoreDesktopLayout() {
    if (state.quantityPlaceholder && state.quantityPlaceholder.parentNode) {
      var quantity = state.purchaseRow && state.purchaseRow.querySelector('.product-form__quantity');
      if (quantity) state.quantityPlaceholder.parentNode.insertBefore(quantity, state.quantityPlaceholder);
    }

    if (state.addButtonPlaceholder && state.addButtonPlaceholder.parentNode) {
      var addButton = state.purchaseRow && state.purchaseRow.querySelector('.product-form__submit[type="submit"], button[name="add"][type="submit"]');
      if (addButton) state.addButtonPlaceholder.parentNode.insertBefore(addButton, state.addButtonPlaceholder);
    }

    if (state.purchaseRow && state.purchaseRow.parentNode && !state.purchaseRow.children.length) {
      state.purchaseRow.parentNode.removeChild(state.purchaseRow);
    }
  }

  function ensureTtOptionsDivider() {
    var containers = Array.prototype.slice.call(document.querySelectorAll('.product-options'));
    containers.forEach(function (container) {
      Array.prototype.slice.call(container.querySelectorAll('.blk-tt-options-divider')).forEach(function (divider) {
        divider.parentNode.removeChild(divider);
      });

      var options = Array.prototype.slice.call(container.querySelectorAll('.product-option'));
      options.forEach(function (option) {
        option.classList.remove('blk-tt-options-split-target');
      });
      if (!options.length) return;

      var hasCustomizeGroup = /(customize|kies een speler|voeg de jouwe toe)/.test(normalizeText(container.textContent));
      var target = options.find(function (option, index) {
        var label = option.querySelector('.product-option__label, label');
        var labelText = normalizeText(label ? label.textContent : option.textContent);
        return /(patch\s*list|patchlijst|badge)/.test(labelText) && (index > 0 || hasCustomizeGroup);
      });

      if (!target) {
        target = options.find(function (option, index) {
          return index > 0 && option.querySelector('select, .custom-select-wrapper');
        });
      }

      if (target) target.classList.add('blk-tt-options-split-target');
    });
  }

  function isElementVisible(node) {
    if (!node || node.nodeType !== 1) return false;
    if (node.hidden || node.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle ? window.getComputedStyle(node) : null;
    if (style && (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0')) return false;
    var rect = node.getBoundingClientRect();
    return rect.width > 20 && rect.height > 20;
  }

  function isSizeChartOpen() {
    var candidates = Array.prototype.slice.call(document.querySelectorAll(
      [
        '.rapsc-modal',
        '.rapsc-popup',
        '.rapsc-container',
        '.rt-size-chart-modal',
        '.rt-size-chart-popup',
        '[class*="size-chart"][class*="modal"]',
        '[class*="sizeguide"]',
        '[id*="size-chart"]',
        '[id*="sizeguide"]'
      ].join(',')
    ));

    return candidates.some(function (node) {
      if (!isElementVisible(node)) return false;
      var text = normalizeText(node.textContent || '');
      return /(maat|lengte|borst|hoogte|gewicht|cm\/kg|size chart|maattabel)/.test(text);
    });
  }

  function updateInboxForSizeChart() {
    document.documentElement.classList.toggle('blk-size-chart-open', isSizeChartOpen());
  }

  function initMobileProductDetail() {
    applyJudgeMeReviewLayout();
    organizeJudgeMeReviewHeader();

    var fieldset = findSizeFieldset(document);
    if (fieldset) updateSizePillWidth(fieldset);

    if (!isMobile()) {
      if (fieldset) {
        fieldset.removeAttribute('data-blk-mobile-size-picker');
        fieldset.removeAttribute('data-blk-expanded');
        var desktopToggle = fieldset.querySelector(':scope > .blk-size-toggle');
        if (desktopToggle) desktopToggle.parentNode.removeChild(desktopToggle);
      }
      restoreDesktopLayout();
      return;
    }

    if (fieldset) ensureToggle(fieldset);

    setupPurchaseRow();
    ensureTtOptionsDivider();
    updateInboxForSizeChart();
  }

  function scheduleInit(withRetries) {
    if (state.initFrame) return;
    state.initFrame = window.requestAnimationFrame(function () {
      state.initFrame = null;
      initMobileProductDetail();
      if (withRetries) {
        state.retryTimers.forEach(function (timer) { window.clearTimeout(timer); });
        state.retryTimers = [250, 800, 1600, 3200, 6000].map(function (delay) {
          return window.setTimeout(initMobileProductDetail, delay);
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { scheduleInit(true); });
  window.addEventListener('load', function () { scheduleInit(true); });
  document.addEventListener('product-info:loaded', function () { scheduleInit(true); });
  document.addEventListener('shopify:section:load', function () { scheduleInit(true); });
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.product-form__input--pill input[type="radio"]')) {
      var fieldset = event.target.closest('.product-form__input--pill');
      if (fieldset && hasCheckedHiddenOption(fieldset)) {
        fieldset.setAttribute('data-blk-expanded', 'true');
        var toggle = fieldset.querySelector('.blk-size-toggle');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
    }
  });

  if (mediaQuery && mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', function () { scheduleInit(true); });
  }

  new MutationObserver(function () {
    scheduleInit(false);
    if (isMobile()) window.setTimeout(updateInboxForSizeChart, 80);
  }).observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['form'],
    childList: true,
    subtree: true
  });

  document.addEventListener('click', function () {
    window.setTimeout(updateInboxForSizeChart, 120);
    window.setTimeout(updateInboxForSizeChart, 450);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') window.setTimeout(updateInboxForSizeChart, 120);
  });

  scheduleInit(true);
})();
/* BLK_MOBILE_PRODUCT_DETAIL_JS_END */

